<style scoped lang="scss" type="text/scss">

</style>

<template>
    <div class="global-relative">
        <loading-placeholder :loading="requesting"></loading-placeholder>
        <el-table :data="taobao" :span-method="objectSpanMethod" stripe border size="small"
                  :max-height="visualAreaHeight" style="width: 100%; margin-top: 1rem;">
            <el-table-column prop="index_text" label="序号" align="center" width="80"></el-table-column>
            <el-table-column prop="school_name" label="学校名称" align="center" min-width="180"></el-table-column>
            <el-table-column prop="team_name" label="队伍名称" align="center" min-width="200"></el-table-column>
            <el-table-column prop="purchasing" label="物资购买联系人" align="center" min-width="200"></el-table-column>
            <el-table-column prop="taobao_account" label="淘宝账号" align="center" min-width="200"></el-table-column>
            <el-table-column prop="name" label="姓名" align="center" min-width="100"></el-table-column>
            <el-table-column prop="gender_text" label="性别" align="center" min-width="50"></el-table-column>
            <el-table-column prop="mobile" label="手机" align="center" min-width="120"></el-table-column>
            <el-table-column prop="email" label="邮箱" align="center" min-width="180"></el-table-column>
        </el-table>
    </div>
</template>

<script>
    import {handlePlayersTaobao} from '../../../../../utils/data-handler';

    export default {
        name: '',
        data () {
            return {
                taobao: [],
                requesting: false
            };
        },
        computed: {
            currentCompetitionId () {
                return this.$store.state.competition.currentCompetitionId;
            },
            visualAreaHeight () {
                return this.$store.getters['layout/adminPlayerInformationOverviewVisualAreaHeight'];
            }
        },
        watch: {
            currentCompetitionId: {
                immediate: true,
                handler (id) {
                    if (id === null || id === undefined) return;
                    this.loadPlayersWithTaobaoByCompetitionId(id);
                }
            }
        },
        methods: {
            objectSpanMethod ({row, column, rowIndex, columnIndex}) {
                if ([0, 1, 2, 3].indexOf(columnIndex) > -1) {
                    if (undefined === row.count) {
                        return {
                            rowspan: 0,
                            colspan: 0
                        };
                    } else {
                        return {
                            rowspan: row.count,
                            colspan: 1
                        };
                    }
                }
            },
            loadPlayersWithTaobaoByCompetitionId (id) {
                this.$normalRequest('player/loadPlayersWithTaobaoByCompetitionId', {
                    competition_id: id
                }, false, false, this, 'requesting').then(data => {
                    this.taobao = handlePlayersTaobao(data);
                });
            }
        }
    };
</script>
